module.exports = __webpack_public_path__ + "media/images/opengraph_share_default_de-bd719d9763d69284ee70104d3d2c8179.jpg";